import { apiFetch } from '../utils/apiClient';

const API_BASE =
  process.env.REACT_APP_Auth_Url || 'https://momentumampapi-stage.insurancegig.com';

const BASE = `${API_BASE}/api/CompanySettings`;

export type HarnessType = 'Claude' | 'Hermes';

export interface CompanyHarnessTypeConfig {
  id: number;
  companyId: number;
  harnessType: HarnessType;
  createdAt?: string;
  updatedAt?: string;
}

export async function getHarnessTypeConfig(): Promise<CompanyHarnessTypeConfig | null> {
  const res = await apiFetch<{ success: boolean; data: CompanyHarnessTypeConfig | null }>(
    `${BASE}/harness-type`,
  );
  return res?.data ?? null;
}

export async function upsertHarnessTypeConfig(
  harnessType: HarnessType,
): Promise<void> {
  await apiFetch(`${BASE}/harness-type/upsert`, {
    method: 'POST',
    body: JSON.stringify({ harnessType }),
  });
}
